// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"Inset_horizontal__2ywLY","vertical":"Inset_vertical__31RwY","typeName":"Inset_typeName__r-r8u"};